import { useTranslation } from 'react-i18next';
import RegularEditor from "../../../components/class/ocean/RegularEditor";
import SimpleHeader from "../../../components/layout/SimpleHeader";

const OceanCreate = () => {
  const { t } = useTranslation();
  return (
    <div className="content scrollbar">
      <SimpleHeader
        iconFile="icon-student-big.svg"
        parentMenu={t('common.menu.class')}
        currentMenu={t('class.ocean.title1')}
      />

      <div>
        <RegularEditor />
      </div>
    </div>
  );
}

export default OceanCreate;
